<template>
  <Modal
    ref="modal"
    class="DeleteGroupModal"
    :heading="messages.group.deleteGroupHeading"
    :size="isExtraSmallPixel ? 'extraSmall' : 'small'"
    @closeModal="onClickModalClose"
  >
    <template v-if="!isGroupInUse && !isError">
      <div class="DeleteGroupModal__modalInner">
        <!-- safe usage of v-html: content is fully static and developer-controlled -->
        <p
          class="DeleteGroupModal__modalText"
          v-html="messages.group.confirm.deleteGroup"
        ></p>
      </div>
      <div class="DeleteGroupModal__modalButton">
        <Button
          tag="button"
          dynamics="secondary"
          :label="messages.common.cancel"
          @click="onClickModalClose"
        />
        <Button
          tag="button"
          dynamics="danger"
          :label="messages.common.delete"
          @click="onClickDelete"
        />
      </div>
    </template>
    <div v-else class="DeleteGroupModal__modalInner">
      <Icon class="DeleteGroupModal__icon" iconName="Exception"></Icon>
      <!-- safe usage of v-html: content is fully static and developer-controlled -->
      <p
        v-if="isGroupInUse"
        class="DeleteGroupModal__modalText"
        v-html="messages.group.info.groupInUse"
      ></p>
      <p
        v-else
        class="DeleteGroupModal__modalText"
        v-html="messages.group.fail.deleteGroup"
      ></p>
      <div class="DeleteGroupModal__modalButton">
        <Button
          tag="button"
          dynamics="secondary"
          :label="messages.common.close"
          @click="onClickModalClose"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
export default {
  name: 'DeleteGroupModal',
};
</script>

<script lang="ts" setup>
import Button from '@spectee/components/Atoms/Button/index.vue';
import Modal from '@spectee/components/Organisms/Modal/index.vue';
import Icon from '@spectee/components/Atoms/IconBase/index.vue';
import { useWindowWidth } from '@spectee/composables/useWindowWidth';
import messages from '../../../../messages.json';

type Props = {
  isGroupInUse: boolean;
  isError: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  isGroupInUse: false,
  isError: false,
});

const { isExtraSmallPixel } = useWindowWidth();

const emit = defineEmits<{
  (e: 'onClickModalClose'): void;
  (e: 'deleteGroupItems'): void;
}>();

const onClickModalClose = () => {
  emit('onClickModalClose');
  return;
};

const onClickDelete = async () => {
  emit('deleteGroupItems');
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;
.DeleteGroupModal {
  padding: $service-unit * 4 $service-unit * 4 $service-unit * 6;

  &__item {
    margin-top: $service-unit * 6;
    font-size: $service-font-size-p;
  }

  &__modalButton {
    display: flex;
    margin-top: $service-unit * 6;
    gap: $service-unit * 3;
    justify-content: center;
  }

  &__modalInner {
    text-align: center;
  }

  &__modalText {
    margin-top: $service-unit * 6;
    font-size: $service-font-size-p;
    line-height: $service-line-height-mf;
  }

  &__icon {
    width: $service-unit * 10;
    margin: $service-unit * 4 $service-unit * 38 0 $service-unit * 38;
    fill: #c33b2e;
  }

  @media (max-width: 424px) {
    &__icon {
      margin-left: $service-unit * 28;
    }
  }
}
</style>
